module.exports = require("git-rev-sync");


//////////////////
// WEBPACK FOOTER
// external "git-rev-sync"
// module id = 129
// module chunks = 0